import { render } from "./SIPServer.vue?vue&type=template&id=2e489240&scoped=true"
import script from "./SIPServer.vue?vue&type=script&lang=js"
export * from "./SIPServer.vue?vue&type=script&lang=js"

import "./SIPServer.vue?vue&type=style&index=0&id=2e489240&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2e489240"

export default script